import { Component, computed, inject } from '@angular/core';
import { STATUS_MODAL_CONFIG, StatusModalData } from '../../models/status-modal.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HighlightedMessageComponent } from '../highlighted-message/highlighted-message.component';

@Component({
  selector: 'app-status-modal',
  imports: [FontAwesomeModule, MatButtonModule, HighlightedMessageComponent],
  templateUrl: './status-modal.component.html',
  styleUrl: './status-modal.component.scss',
})
export class StatusModalComponent {
  private readonly dialogRef = inject(MatDialogRef<StatusModalComponent>);

  readonly data = inject<StatusModalData>(MAT_DIALOG_DATA);

  readonly config = computed(() => STATUS_MODAL_CONFIG[this.data.state]);

  readonly title = computed(() => this.data.title || this.config().title);

  public close(): void {
    this.dialogRef.close();
  }
}
